/**
 * Created by razial on 21.09.2026.
 */

cleverapps.overrideStyles(cleverapps.styles.BoostTimeMissionWindow, {
    height: 1000,

    person: "warlock",

    animation: {
        x: { align: "center" },
        y: { align: "center", dy: 350 }
    },

    description: {
        x: { align: "center" },
        y: { align: "center", dy: -460 }
    },

    ribbon: {
        x: { align: "center", dx: 277 },
        y: { align: "center", dy: 310 }
    },

    coinsReward: {
        x: { align: "center", dx: -60 },
        y: { align: "center", dy: -240 }
    },

    buyPackButton: {
        x: { align: "center", dx: 285 },
        y: { align: "center", dy: -270 }
    }
});
